import { cn } from "@/lib/utils";

/**
 * ROC SEARCH INTERFACE SYSTEM
 * Etiqueta de sistema: índice numérico + label mono en versalitas.
 * Puramente tipográfica (sin pills, sin gradientes, sin emojis).
 */
export const RocSignalLabel = ({
  index,
  children,
  className,
  tone = "default",
}: {
  index?: string;
  children: React.ReactNode;
  className?: string;
  tone?: "default" | "invert";
}) => (
  <p
    className={cn(
      "flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.22em]",
      tone === "invert" ? "text-slate-400" : "text-muted-foreground",
      className,
    )}
  >
    {index && <span className="text-brand">{index}</span>}
    <span className="h-px w-6 bg-brand/60" aria-hidden="true" />
    <span>{children}</span>
  </p>
);

/** Marca de coordenada fina para esquinas de bloques del sistema. */
export const RocCorner = ({ className }: { className?: string }) => (
  <span
    aria-hidden="true"
    className={cn("pointer-events-none absolute h-2 w-2 border-brand/70", className)}
  />
);
